<template>
  <div class="container lms-wrapper-two">
    <!-- <student-nav :obj.sync="statObj"></student-nav> -->
    <student-nav></student-nav>
    <div class="lms-content">
      <student-header class="filled" @toggle-navbar="toggleNavbar($event)" />
      <div
        class="lms-content-body container "
        style="bottom: 0; height: calc(100vh - 80px); overflow-y: scroll"
      >
        <div class="row pd-lg-40">
          <div class="col-sm-6">
            <div class="card rounded-20 bg-white">
              <div class="card-body pd-40">
                <div>
                  <!-- <h4>Create New Account</h4>
              <p class="tx-color-03">It's free to signup and only takes a minute.</p> -->
                  <div class="form-group">
                    <!-- <label>Таны нэр</label> -->
                    <input v-model="name"
                      type="text"
                      class="form-control"
                      placeholder="Таны нэр"
                    />
                  </div>
                  <div class="form-group">
                    <!-- <label>Цахим шуудан</label> -->
                    <input v-model="mail"
                      type="email"
                      class="form-control"
                      placeholder="Цахим шуудан"
                    />
                  </div>
                  <div class="form-group">
                    <!-- <label class="mg-b-0-f">Зурвас</label> -->
                    <textarea v-model="message"
                      rows="4"
                      class="form-control"
                      placeholder="Зурвас"
                    ></textarea>
                  </div>
                  <button @click="sendFeedback()" class="btn btn-primary btn-block">Илгээх</button>
                  <!-- <div class="tx-13 mg-t-20 tx-center">Already have an account? <a href="page-signup.html">Sign In</a></div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="card rounded-20 bg-white">
              <div class="card-body pd-40">
                <div>
                  <h4 class="pd-b-20">Холбоо барих</h4>
                  <ul class="list-unstyled">
                    <li class="d-flex">
                      <div class="pd-r-20">
                        <span class="">
                          <feather type="mail" class="mr-r-5"></feather>
                        </span>
                      </div>
                      <div>
                        <span class="tx-12 text-muted">Цахим шуудан:</span>
                        <p class="tx-14 tx-semibold mg-t-3">
                          {{sttc.mail}}
                        </p>
                      </div>
                    </li>
                    <li class="d-flex">
                      <div class="pd-r-20">
                        <span class="">
                          <feather type="phone" class="mr-r-5"></feather>
                        </span>
                      </div>
                      <div>
                        <span class="tx-12 text-muted">Холбогдох утас:</span>
                        <p class="tx-14 tx-semibold mg-t-3">{{ sttc.phone }}</p>
                      </div>
                    </li>
                    <li class="d-flex">
                      <div class="pd-r-20">
                        <span class="">
                          <feather type="map-pin" class="mr-r-5"></feather>
                        </span>
                      </div>
                      <div>
                        <span class="tx-12 text-muted">Хаяг байршил:</span>
                        <p class="tx-14 tx-semibold mg-t-3">
                          {{ sttc.address }}
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <h3>FAQ</h3>
            <Collapse>
              <CollapseItem v-for="(f,i) in faqs" :key="i">
                <template slot="title">
                  <div class="pd-l-20">
                    <feather type="chevron-down" class="pd-r-10"></feather>
                    {{ f.task }}
                  </div>
                </template>
                <div class="pd-20" v-html="f.taskDesc"></div>
              </CollapseItem>
            </Collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
//import vueCustomScrollbar from "vue-custom-scrollbar";
import "element-ui/lib/theme-chalk/index.css";
import { Collapse, CollapseItem, Notification } from "element-ui";
import { request } from "@/api/all";

export default {
  components: {
    Collapse,
    CollapseItem,
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      nowDate: null,
      name:"",
      mail:"",
      message:"",
      faqs: [],
      sttc:{
        mail: null,
        phone: null,
        address: null,
      },
    };
  },
  created(){
    //alert('1');
  },
  mounted(){
    // require('@/assets/scss/pages/learning.scss');
    let _companyMail = this.$store.state.app.groupSettings.filter(x => x.key == "companyMail");
    if (_companyMail.length > 0) {
      this.sttc.mail = _companyMail[0].value;
    }

    let _companyPhone = this.$store.state.app.groupSettings.filter(x => x.key == "companyPhone");
    if (_companyPhone.length > 0) {
      this.sttc.phone = _companyPhone[0].value;
    }

    let _companyAddress = this.$store.state.app.groupSettings.filter(x => x.key == "companyAddress");
    if (_companyAddress.length > 0) {
      this.sttc.address = _companyAddress[0].value;
    }

    this.loadFaqs();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    loadFaqs(){
      //webItemCategory
      //lmscontactfaq key
      request({
        api: { method: "GET", url: "type/getData" },
        params: {
          key: "webItemCategory"
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log(res.data.types);
          let _key= res.data.types.filter(x=>x.s3=='lmscontactfaq');
          if(_key.length){
            request({
              api: { method: "POST", url: "TaskCore/GetCoreList" },
              data: {
                skip: 0,
                size: 100,
                ot: 357,
                model: { isPublic: true, locTypeId1: _key[0]['id']  }
              },
              store: this.$store,
            }).then((rest) => {
              if (rest != false) {
                this.faqs= _.orderBy(rest.data.tasks, ["ord"], ["asc"]);
              }
            });
          }
        }
      });
    },
    sendFeedback(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/Learn/PostContactMail" },
        data: {
          name: this.name,
          mail: this.mail,
          message: this.message
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.name= null;
          this.mail= null;
          this.message= null;

          Notification.success({
                message:
                  "Таны зурвасыг амжилттай хүлээн авлаа.",
                title: "Амжилттай",
                duration: 10000,
                type: "success",
                position: "top-right",
                offset: 50,
              });
        }
      });

    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
  },
};
</script>
